import JavascriptIcon from "@mui/icons-material/Javascript";
import CssIcon from "@mui/icons-material/Css";
import ApiIcon from "@mui/icons-material/Api";
import { FaReact } from "react-icons/fa";
import { FaCss3Alt } from "react-icons/fa";
import { IoLogoJavascript } from "react-icons/io";
import { MdApi } from "react-icons/md";
export const project = {
  javascript: {
    icon: IoLogoJavascript,
    description:
      " Vanilla js, ES6 features, module architecture, file input,drag and drop Api, single page application these kind of projects are demonstrated here",
    data: [
      {
        name: "meme generator",
        link: "https://briyani-monster.github.io/meme-generator/",
        github: "https://github.com/Briyani-monster/meme-generator",
        image: "../../images/memegenerator.png",
        description:
          "A minimalist website for to create meme. I have used html canvas api.",
        languages: ["HTML canvas", "javascript"],
      },
      {
        name: "Todo List",
        image: "../../images/ToDOist.png",
        github: "https://github.com/Briyani-monster/TO-DO_LIST",
        description:
          "To do list App with CRUD operations and Drag and drop functionality",
        link: "https://briyani-monster.github.io/TO-DO_LIST/",
        languages: ["Javascript", " HTML Drag and Drop API"],
      },

      {
        name: "Recipe App",
        image: "../../images/recipeapp.png",
        github: "https://github.com/Briyani-monster/Recipeapp",
        description:
          "Recipe App is a Single Page Application For using javascript.",
        link: "https://briyani-monster.github.io/Recipeapp/index.html",
        languages: ["Javascript", "Single Page Application"],
      },

      {
        name: "True Note",
        image: "../../images/advicegenerator.png",
        github: "https://github.com/Briyani-monster/TruNote/tree/code",
        description:
          "Minimilist note app using javascript module and javascript class",
        link: "https://elated-lumiere-f4d7ea.netlify.app/",
        languages: ["Javascript", "JS module", "Js class"],
      },
      {
        name: "Budget Tracker",
        image: "../../images/budgettracker.png",
        github: "https://github.com/Briyani-monster/budget-tracker",
        description:
          "A minimilist budget Managing App with Expense and Income tabs and have Crud Operations",
        link: "https://briyani-monster.github.io/budget-tracker/",
        languages: ["Javascript"],
      },
    ],
  },
  UI: {
    icon: FaCss3Alt,
    description:
      "Improving front-end coding skills by building real HTML, CSS and JavaScript challenges whilst working to professional designs.",
    data: [
      {
        name: "Feature Section UI",
        image: "../../images/featureSectionUI.png",
        github: "https://github.com/Briyani-monster/Feature-Section-UI-Design",
        description: "Simple HTML CSS Feature Section",
        link: "https://briyani-monster.github.io/Feature-Section-UI-Design/#",
        languages: ["HTML", "CSS"],
      },
      {
        name: "Omni Food Landing Page",
        image: "../../images/omnifood.png",
        github: "https://github.com/Briyani-monster/OmniFood",
        description: "Landing Page of omnifood",
        link: "https://briyani-monster.github.io/OmniFood/",
        languages: ["HTML", "CSS", "JavaScript"],
      },
      {
        name: "Sunny Side landing Page",
        image: "../../images/sunnyside.jpg",
        github:
          "https://github.com/Briyani-monster/Sunnyside-agency-landing-page",
        description: "Landing Page of Sunny Side",
        link: "https://briyani-monster.github.io/Sunnyside-agency-landing-page/",
        languages: ["React", "React Router"],
      },
    ],
  },
  "javascript api": {
    icon: MdApi,
    description:
      "These project are made by using HTML, CSS and Javascript using some API. and Tried different concepts like Infinite scrolling , text to speech and simple api's.",
    data: [
      {
        name: "joke Teller",
        image: "../../images/Joketeller.png",
        github: "https://github.com/Briyani-monster/joke-teller",
        description:
          "a joke teller website which speaks a programming joke everytime when it is button is clicked",
        link: "https://briyani-monster.github.io/joke-teller/",
        languages: ["Javascript", "voice over API", "joke teller Api"],
      },
      {
        name: "Infinite Scroll",
        image: "../../images/InfiniteScroll.png",
        github: "https://github.com/Briyani-monster/infinity-scroll",
        description:
          "a images website which have infinite scroll effect also have unsplash api initegration",
        link: "https://briyani-monster.github.io/infinity-scroll/",
        languages: ["Javascript", "Unspalsh APi"],
      },
      {
        name: "Advice Generator",
        image: "../../images/advicegenerator.png",
        github: "https://github.com/Briyani-monster/Advice-generator",
        description:
          "advice generator app using the Advice Slip API and sass is used for styling",
        link: "https://briyani-monster.github.io/Advice-generator/",
        languages: ["Javascript", "Sass", "Advice Slip API"],
      },
    ],
  },
  react: {
    icon: FaReact,
    description:
      "This are some more project of made using React, react Hooks, Tailwind css, css and react Router capability",
    data: [
      {
        name: "Resume Builder",
        image: "../../images/resumeBuilder.png",
        github: "https://github.com/Briyani-monster/Resume-builder",
        description:
          "Resume Builder website with drag and drop and editing color change functionality",
        link: "https://mellifluous-fairy-320d40.netlify.app/",
        languages: ["React", "React Hooks"],
      },
      {
        name: "eggllet landing Page",
        image: "../../images/eglletgif.gif",
        github: "https://github.com/Briyani-monster/eggllet",
        description: "Landing Page of Sunny Side using Talwind css",
        link: "https://gentle-smakager-6d2abc.netlify.app/",
        languages: ["React", "React Router", "Talwind css"],
      },
    ],
  },
  main: [
    {
      name: "Budget Tracker v2.0",
      video: "https://www.youtube.com/embed/V889-GRk9_M",
      github: "https://github.com/Briyani-monster/budget-tracker-2.0",
      description:
        "A Budget Tracking App version 2.0 this version have user authentication monthly expense chart and summary of expense and good UI and some  data Filteration",
      previous: "https://briyani-monster.github.io/budget-tracker/",
      link: "https://budget-tracker2.web.app/signin",
      languages: ["React", "React Hooks", "context Api", "React Router"],
    },
    {
      name: "Tru Note v2.0",
      video: "https://www.youtube.com/embed/8Lvit-mcrNo",
      github: "https://github.com/Briyani-monster/trunote2.0",
      description:
        "Tru Note a Notes taking website . This website is better at managing the notes then it's previous version  it have Archive, Trashing, and pinning notes (Google keep ) Functionality. ",
      previous: "https://elated-lumiere-f4d7ea.netlify.app/",
      link: "https://sensational-kelpie-748ab2.netlify.app/",
      languages: ["React", "React Hooks", "context Api"],
    },
  ],
};

export const social = [
  { name: "codepen", link: "https://codepen.io/briyani-monster" },
  { name: "linkedin", link: "https://www.linkedin.com/in/gsashishfontenddev/" },
  { name: "twitter", link: "https://twitter.com/iamGSashish" },
  { name: "github", link: "https://github.com/Briyani-monster" },
  { name: "instagram", link: "https://www.instagram.com/biryani.monster_/" },
];
export const mail = "gsashishemail@gmail.com";
export const programming = [
  { name: "leetcode", link: "https://leetcode.com/gsashishemail/" },
  {
    name: "geeks for geeks",
    link: "https://auth.geeksforgeeks.org/user/gsashish69/profile",
  },
];
export const skills = {
  language: ["HTML/CSS", "javascript", "SASS", "python", "java", "c/c++"],
  library: ["React", "Redux"],
  "CSS framework": ["talwind css", "material ui"],
  design: ["Figma", "Adobe Illustrator", "Adobe Photoshop"],
  database: ["sql"],
  tools: ["git", "vs code", "npm", "yarn", "maven"],
  testing: ["Jest", "familarity with Selenium"],
};
export const exprience = [
  {
    name: "Intern in Cognizant",
    designation: "QEA Intern",
    startdate: "Mar-2021",
    endDate: "July-2021",
    responsibilities: [
      "Based on Requirement performed testing on the website manaually and Automatically using  Selenium width Java. and create QEA report based on test cases",
    ],
    tools: ["java", "selenium", "x-path", "maven"],
  },
  {
    name: "Programmer Analyst",
    designation: "Tibco bpm infrastructure Support",
    startdate: "oct-2021",
    endDate: "present",
    responsibilities: [
      "Installing and maintaining operating environments",
      "Monitoring these operating environments",
      "Documenting all reported malfunctions and actions taken in response.",
      "Updating any software and hardware where necessary",
    ],
    tools: ["tibco bpm", "linux"],
  },
];
